import { Dispatch } from 'redux';

import * as Actions from '../actions/whatsNewDetail';
import { isMobile } from '../utils/MobileCheck';
import ReplaceStyleKeywords from '../utils/ReplaceStyleKeywords';
import AbstractScenario from './AbstractScenario';

/**
 * What's Newシナリオファクトリ
 */
export default class WhatsNewDetailScenarioFactory {
	/**
	 * eラーニング全問一画面テスト結果情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchWhatsNews(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process(arg: {}) {
				const param = {
					isMobile: isMobile(),
				};
				return this.read(
					'per_notice_WhatsNewListBlockModel',
					param
				).then(data => {
					const whatsNews = data.whatsNewList.map((w: any) =>
						WhatsNewDetailScenarioFactory.toWhatsNew(w)
					);
					this.dispatch(Actions.setWhatsNewList({ whatsNews }));
				});
			}
		}(dispatch, token);
		return scenario;
	}

	protected static toWhatsNew(from: any) {
		const to: Actions.IWHatsNew = {
			careerID: from.careerID,
			careerTypeID: from.careerTypeID,
			classID: from.classID,
			contact: from.contact,
			externalCourseType: from.externalCourseType,
			isBtnApply: from.isBtnApply,
			isBtnResultApply: from.isBtnResultApply,
			message: from.message,
			messageID: from.messageID,
			messageList: from.messageList.map((m: string) =>
				ReplaceStyleKeywords.replaceStyleKeywords(m)
			),
			startDateStr: from.startDateStr,
			titleList: from.titleList.map((m: string) =>
				ReplaceStyleKeywords.replaceStyleKeywords(m)
			),
		};
		return to;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/WhatsNewDetailScenarioFactory.ts